import { ShiftRequestType } from 'types/shift-requests';

const CACHE_KEY = 'BYOD-shift-request-types';

/**
 * Cache shift request types in localStorage
 */
export const cacheShiftRequestTypes = (types: ShiftRequestType[]): void => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(types));
  } catch (error) {
    console.warn('Failed to cache shift request types:', error);
  }
};

/**
 * Get cached shift request types from localStorage
 */
export const getCachedShiftRequestTypes = (): ShiftRequestType[] | null => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (error) {
    console.warn('Failed to retrieve cached shift request types:', error);
    return null;
  }
};

/**
 * Clear shift request types cache
 */
export const clearShiftRequestTypesCache = (): void => {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch (error) {
    console.warn('Failed to clear shift request types cache:', error);
  }
};

/**
 * Get shift request type label by ID from cached types
 */
export const getShiftRequestTypeLabel = (typeId: number | string): string => {
  const cached = getCachedShiftRequestTypes();
  if (!cached) return 'N/A';
  
  // Extract ID from IRI if needed (e.g., "/api/shift_request_types/4" -> 4)
  const id = typeof typeId === 'string' 
    ? parseInt(typeId.split('/').pop() || '0', 10)
    : typeId;
  
  const type = cached.find(t => t.id === id);
  return type?.label || 'N/A';
};

/**
 * Get shift request type label from IRI string
 */
export const getShiftRequestTypeLabelFromIRI = (iri: string): string => {
  const cached = getCachedShiftRequestTypes();
  if (!cached) return 'N/A';
  console.log('IRI:', iri);
  // Extract ID from IRI (e.g., "/api/shift_request_types/4" -> 4)
  const id = parseInt(iri.split('/').pop() || '0', 10);
  
  const type = cached.find(t => t.id === id);
  return type?.label || 'N/A';
};
